import { Typography, TypographyProps } from './Typography';

type Props = {
  text: string;
} & TypographyProps;

export const TypographyBold: React.FC<Props> = ({ text, ...rest }) => (
  <Typography component="span" sx={{ fontWeight: 500 }} variant="body2" {...rest}>
    {text}
  </Typography>
);
